import { useMemo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import { useMultiselectFilterDisplayText } from "../../filters/hooks/useMultiselectFilterDisplayText";
import { SimpleMultiselectFilter } from "../../filters/SimpleMultiselectFilter";
import { newsTypeTranslationKeyMap } from "../utils/translationKeysConfig";

import { NEWS_TYPES } from "./constants";
import { useNewsAlertsFilterStore } from "./useNewsAlertsFilterStore";

export const NewsType = () => {
    const { translate } = useTranslate();
    const selectedNewsTypes = useNewsAlertsFilterStore((state) => state.selectedNewsTypes);
    const isDefaultNewsTypesSelected = useNewsAlertsFilterStore((state) => state.isDefaultNewsTypesSelected);
    const setSelectedNewsTypes = useNewsAlertsFilterStore((state) => state.setSelectedNewsTypes);

    const options = useMemo(
        () => NEWS_TYPES.map((type) => ({ id: type, label: translate(newsTypeTranslationKeyMap[type]) })),
        [translate],
    );

    const newsTypeDisplayText = useMultiselectFilterDisplayText({
        defaultSelectionKey: "activation.alerts.filters.news-type.all",
        isDefaultSelected: isDefaultNewsTypesSelected,
        nonDefaultSelectionKey: "activation.alerts.filters.news-type.some",
        selectedFilterData: selectedNewsTypes,
    });

    return (
        <SimpleMultiselectFilter
            appliedItems={selectedNewsTypes}
            dataAutomation="news-type-filter"
            isFilterSelected={!isDefaultNewsTypesSelected}
            onApplyChanges={setSelectedNewsTypes}
            options={options}
        >
            {newsTypeDisplayText}
        </SimpleMultiselectFilter>
    );
};
